import React, { useState, useRef } from "react";
import { useHover } from "react-aria";
import { Link } from "gatsby";

interface idropdownProps {
  linkItem: any;
}

const Dropdownlink: React.FC<idropdownProps> = (props) => {
  const { hoverProps, isHovered } = useHover(props as any);

  return (
    <>
      <li className="relative">
        <Link
          {...hoverProps}
          activeClassName="active"
          to={props.linkItem.url}
          style={{ position: "relative" }}
          className="flex gap-2 items-center font-bold hover:text-blue-600 group h-[80px] active-link"
        >
          {props.linkItem.text}
        </Link>
        <div
          className={`${
            isHovered ? "flex" : "hidden"
          } dropdownlink absolute left-0 w-max h-max z-10 top-[60px]`}
          {...hoverProps}
        >
          <ul className="flex flex-col w-max rounded-md shadow-xl bg-white overflow-hidden border-t-1 border-solid border-gray-400">
            {props.linkItem?.dropdown?.map(
              (dropdownItem: any, dropdownidx: number) => (
                <li key={dropdownidx}>
                  <Link
                    className="p-4 text-base font-semibold text-black hover:text-blue-800 hover:bg-blue-100 w-full h-max flex"
                    activeClassName="active"
                    to={dropdownItem.urlDropdown}
                  >
                    {dropdownItem.textDropdown}
                  </Link>
                </li>
              )
            )}
          </ul>
        </div>
      </li>
    </>
  );
};

export default Dropdownlink;
